import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import HeroCarousel from 'components/HeroCarousel';
import HeroSlideThemeable from 'components/HeroSlide/HeroSlideThemeable';
import InlineVideoPlayer from 'components/HeroSlide/InlineVideoPlayer';
import PlayButton from 'components/HeroSlide/PlayButton';
import MiniNavigation from 'components/MiniNavigation';
import { MINI_NAV_POSITIONS } from 'components/MiniNavigation/constants';
import { OVERLAY_POSITIONS } from 'constants/homepage';
import HeroModel from 'models/Hero';
import Settings from 'utils/Settings';

const HomepageHero = ({ hero = {}, isModalOpen, openVideoModal }) => {
  const videoUrl = get(hero, 'videoUrl');

  const [inlineVideoOpen, setInlineVideoOpen] = useState(false);

  const handleOpenVideo = useCallback(() => {
    openVideoModal(videoUrl);
  }, [openVideoModal, videoUrl]);

  const openInlineVideo = useCallback(() => {
    setInlineVideoOpen(true);
  }, []);

  const closeInlineVideo = () => {
    setInlineVideoOpen(false);
  };

  return (
    <div className="HomepageHero relative mb-6 md:mb-10">
      <MiniNavigation {...Settings.miniNavigation} position={MINI_NAV_POSITIONS.TOP} />

      <div className="relative aspect-4/5 md:aspect-[1/.43]">
        <HeroCarousel decisionId={hero.decisionId} variationId={hero.variationId}>
          {hero?.heroSlides?.map((heroSlide, index) => (
            <HeroSlideThemeable
              key={get(heroSlide, 'internalName') || index}
              data={heroSlide}
              openInlineVideo={openInlineVideo}
              videoModalOpen={isModalOpen}
            />
          ))}
        </HeroCarousel>
        {videoUrl && (
          <div className="absolute left-4 top-4 md:left-10 md:top-10">
            <PlayButton onClick={handleOpenVideo} className="md:hidden" />
            <PlayButton onClick={openInlineVideo} className="hidden md:block" />
          </div>
        )}
      </div>
      {inlineVideoOpen && videoUrl && (
        <InlineVideoPlayer onClose={closeInlineVideo} videoUrl={videoUrl} />
      )}
    </div>
  );
};

HomepageHero.propTypes = {
  hero: PropTypes.instanceOf(HeroModel),
  isModalOpen: PropTypes.bool,
  isMiniNavigationExperimentLoading: PropTypes.bool,
  miniNavigationPlacementExperimentAnalyticsData: PropTypes.shape({
    campaignId: PropTypes.string,
    variationId: PropTypes.number,
  }),
  openVideoModal: PropTypes.func,
  overlayPositionDesktop: PropTypes.oneOf(Object.values(OVERLAY_POSITIONS)),
  overlayPositionMobile: PropTypes.oneOf(Object.values(OVERLAY_POSITIONS)),
  miniNavigationPosition: PropTypes.oneOf(Object.values(MINI_NAV_POSITIONS)),
};

export default HomepageHero;
